class VideoComment extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }
  
    connectedCallback() {
      this.initSlider();
      this.setupVideoControls();
      console.log('VideoComment component initialized');
    }
  
    initSlider(){
      const container    = this.querySelector('.swiper-container');
      const paginationEl = this.querySelector('.swiper-pagination');
      const prevBtn      = this.querySelector('.swiper-button-prev');
      const nextBtn      = this.querySelector('.swiper-button-next');
  
      this.swiper = new Swiper(container, {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 6,
        threshold: 30,
        loop: true,
        centeredSlides: true,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        touchStartPreventDefault: false,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
            989: {
                slidesPerView: 'auto',
                spaceBetween: 18,
                loop: false,
                centeredSlides: false,
            },
        },
      });

      this.swiperComment = new Swiper('.video-comment__comment.swiper-comment', {
        slidesPerView: 1.3,
        spaceBetween: 6,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          650: {
            slidesPerView: 2.3,
            spaceBetween: 18,
            centeredSlides: false,
            centeredSlidesBounds: false
          },
          989: {
            slidesPerView: 3,
            spaceBetween: 18,
            centeredSlides: false,
            centeredSlidesBounds: false
          },
          1100: {
            slidesPerView: 3.9
          }
        }
      });
      
    }
  
    setupVideoControls() {
      this.querySelectorAll(".video-comment__content").forEach((videoContainer) => {
        const video       = videoContainer.querySelector("video");
        const stopButton  = videoContainer.querySelector(".video-comment__button-stop");
        const playButton  = videoContainer.querySelector(".video-comment__button-play");
        const soundButton = videoContainer.querySelector(".video-comment__button-sound");
        const img         = videoContainer.querySelector("img");

        if (!video) return;

        let soundOnIcon  = null;
        let soundOffIcon = null;

        if (soundButton) {
          soundOnIcon  = soundButton.querySelector(".sound-on");
          soundOffIcon = soundButton.querySelector(".sound-off");
        }

        video.controls = false;

        if (stopButton) {
          stopButton.style.display = "none";
        }

        const toggleVideo = () => {
          if (!video) return;

          if (video.paused) {
            if (img) img.style.display = "none";
            video.play().catch((err) => console.error("Erreur en jouant la vidéo:", err));
            if (playButton) playButton.style.display = "none";
            if (stopButton) stopButton.style.display = "flex";
          } else {
            video.pause();
            if (playButton) playButton.style.display = "flex";
            if (stopButton) stopButton.style.display = "none";
          }
        };

        if (img)   img.addEventListener("click", toggleVideo);
        video.addEventListener("click", toggleVideo);

        if (playButton) {
          playButton.addEventListener("click", toggleVideo);
          playButton.addEventListener("click", () => {
            console.log("on a cliquer sur le playButton");
          });
        }

        if (stopButton) {
          stopButton.addEventListener("click", toggleVideo);
        }

        if (soundButton && soundOnIcon && soundOffIcon) {
          soundButton.addEventListener("click", () => {
            video.muted = !video.muted;
            soundOnIcon.style.display  = video.muted ? "none"        : "inline-block";
            soundOffIcon.style.display = video.muted ? "inline-block" : "none";
          });
        }
      });
    }

  }
  
  customElements.define('video-comment', VideoComment);
  